import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../../components/commonComponent/Form";
import { FIELDS, MODE } from "../../../../constants/SiteConstants";
import "../../../../styles/Form.css";

const API_URL = process.env.REACT_APP_API_URL;

const AddProductCategory = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const fields = [
    {
      label: FIELDS.NAME,
      name: "name",
      placeholder: "Enter Name",
      required: true,
    },
    {
      label: FIELDS.SLUG,
      name: "slug",
      placeholder: "Enter Slug",
      required: true,
    },
    {
      label: "Banner",
      name: "images",
      placeholder: "Choose Image",
      type: "file",
      // required: true,
      multiple: true,
    },
  ];

  // ✅ Upload single image to your API
  const handleImageUpload = async (file) => {
    if (!file) {
      toast.error("No file selected!");
      return null;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch(`${API_URL}/image/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Upload failed");
      }

      return data.imageUrl;
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error("Error uploading image: " + error.message);
      return null;
    }
  };

  // ✅ Submit form after uploading all images
  const handleSubmit = async (formData) => {
    try {
      if (imageFiles.length > 0) {
        const uploadedImageUrls = await Promise.all(
          imageFiles.map((file) => handleImageUpload(file))
        );

        const filtered = uploadedImageUrls.filter((url) => url !== null);
        formData.image = filtered[0]; // Send single string, not array
      }


      await axios.post(
        `${API_URL}/productcategory/createproductcategory`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Product category added successfully!", { autoClose: 1000 });
      navigate("/product-category");
    } catch (error) {
      console.error("Add Category Error:", error);
      toast.error("Error adding product category", { autoClose: 1000 });
    }
  };

  // ✅ On file select
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setImageFiles(files);
      const previews = files.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Product Category
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/product-category")}
        >
          &times;
        </button>
      </div>
      <Form
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        imagePreview={imagePreviews}
        handleImageChange={handleImageChange}
      />
    </div>
  );
};

export default AddProductCategory;
